import { useEffect, useState } from 'react'
import { apiCall } from '../config/api'

export function useAutocomplete<T>(
  textToSearch: string,
  uri: string,
  minLength: number
) {
  // setear array autocomplete a vacío
  const [data, setData] = useState<T[]>([])
  const [loader, setLoader] = useState<boolean>(false)

  useEffect(() => {
    setLoader(false)
    setData([])
    if (data.length === 0) {
      // si se escribieron mas de tres caracateres
      if (textToSearch.length >= minLength) {
        setLoader(true)
        setTimeout(() => {
          apiCall('GET', uri)
            .then((response) => {
              setData(response.data)
            })
            .catch((error) => {
              console.log('error: ', error)
            })

          setLoader(false)
        }, 500)
      }
    }
  }, [textToSearch, minLength])

  return { data, loader }
}

export default useAutocomplete
